import ethLogo from 'libs/tokens/img/eth.svg';
import usdcLogo from 'libs/tokens/img/usdc.svg';
import wethLogo from 'libs/tokens/img/weth.svg';
// import xvsLogo from 'libs/tokens/img/lela.svg';
import lelaLogo from 'libs/tokens/img/lela.png'
import bobaLogo from 'libs/tokens/img/boba.png'
import bobaETHLogo from 'libs/tokens/img/bobaETH.webp'
import type { Token } from 'types';

const ethToken: Token = {
  address: '0x0000000000000000000000000000000000000000',
  decimals: 18,
  symbol: 'ETH',
  asset: ethLogo,
  isNative: true,
};

export const tokens: Token[] = [
  ethToken,
  {
    symbol: "BOBA",
    decimals: 18,
    address: "0xa18bF3994C0Cc6E3b63ac420308E5383f53120D7",
    asset: bobaLogo
  }, {
    symbol: "WETH",
    decimals: 18,
    address: "0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000",
    asset: wethLogo,
  },
  {
    symbol: "LELA",
    decimals: 18,
    address: "0xDD9886B54870c5172B09B1277de5ae3d52c3C2BC",
    asset: lelaLogo,
  },
  {
    symbol: "USDC",
    decimals: 6,
    address: "0x66a2A913e447d6b4BF33EFbec43aAeF87890FBbc",
    asset: usdcLogo
  },
  {
    symbol: "BETH",
    decimals: 18,
    address: "0x52E4d8989fa8b3E1C06696e7b16DEf5d7707A0d1",
    asset: bobaETHLogo
  }
];

export const tenderlyTokens: Token[] = [
  ethToken,
  {
    symbol: "BOBA",
    decimals: 18,
    address: "0x30e307172c77D122b147Bc145FE8fC534A6f40Af",
    asset: bobaLogo
  }, {
    symbol: "WETH",
    decimals: 18,
    address: "0x625b845e406b28F1356f646DdAaDd0B4e3318d5b",
    asset: wethLogo,
  },
  {
    symbol: "LELA",
    decimals: 18,
    address: "0xDD9886B54870c5172B09B1277de5ae3d52c3C2BC",
    asset: lelaLogo,
  },
  {
    symbol: "USDC",
    decimals: 6,
    address: "0x4b410Dd703C4d1eE8771A6d42aD0BB3d11df0B2f",
    asset: usdcLogo
  }
];